







































































































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { checkResult } from '../helpers/api';
import { useRouter } from '../router';
import { getStore } from '../store';

const componentName = 'UserDelete';

export default defineComponent({
    name: componentName,

    setup() {
        const store = getStore(), { router } = useRouter();

        const state = reactive({
            deleteAccountErrorGeneric: false,
            deleteAccountErrorPassword: false,
            deleteAccountProgress: false,
            accountDeleteSuccess: false
        });

        const form = reactive({
            password: ''
        });

        const user = computed(() => store.state.loggedUser);

        const onCancel = () => {
            router.replace({ name: 'user-dashboard', query: router.currentRoute.query });
        }

        const onDeleteAccount = async () => {
            state.deleteAccountErrorGeneric = false;
            state.deleteAccountErrorPassword = false;
            state.deleteAccountProgress = true;

            const res = await store.dispatch('deleteUser', { password: form.password })

            console.log("DELETE RES", res);

            state.deleteAccountProgress = false;

            if (checkResult(res)) {
                state.accountDeleteSuccess = true;
            }
            else {
                if (res.resultCode == 'WRONG-PASSWORD') {
                    state.deleteAccountErrorPassword = true;
                }
                else {
                    state.deleteAccountErrorGeneric = true;
                }
            }
        };

        return {
            state,
            form,
            user,

            onCancel,
            onDeleteAccount
        };
    },
});
